var _regeneratorRuntime = require("/builds/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/builds/node_modules/@babel/runtime/helpers/slicedToArray.js");

!function (n, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("redux-saga"));else if ("function" == typeof define && define.amd) define(["redux-saga"], e);else {
    var t = "object" == typeof exports ? e(require("redux-saga")) : e(n["redux-saga"]);

    for (var r in t) {
      ("object" == typeof exports ? exports : n)[r] = t[r];
    }
  }
}(this, function (n) {
  return function (n) {
    var e = {};

    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) {
        t.d(r, o, function (e) {
          return n[e];
        }.bind(null, o));
      }
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 1);
  }([function (e, t) {
    e.exports = n;
  }, function (n, e, t) {
    "use strict";

    t.r(e);

    var r = t(0),
        o = function o(n) {
      return "@@redux-saga/" + n;
    },
        u = o("IO"),
        i = o("MULTICAST");

    var c = function c(n) {
      return null == n;
    },
        f = function f(n) {
      return null != n;
    },
        a = function a(n) {
      return "function" == typeof n;
    },
        l = function l(n) {
      return "string" == typeof n;
    },
        d = Array.isArray,
        y = function n(e) {
      return e && (l(e) || s(e) || a(e) || d(e) && e.every(n));
    },
        p = function p(n) {
      return n && a(n.take) && a(n.close);
    },
        s = function s(n) {
      return Boolean(n) && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype;
    },
        b = function b(n) {
      return p(n) && n[i];
    };

    "function" == typeof Symbol && Symbol.asyncIterator && Symbol.asyncIterator;

    var v = "TAKE",
        m = "PUT",
        x = "ALL",
        g = "CALL",
        j = "CANCELLED",
        S = function S(n, e) {
      var t;
      return (t = {})[u] = !0, t.combinator = !1, t.type = n, t.payload = e, t;
    };

    function h(n, e) {
      return void 0 === n && (n = "*"), y(n) ? S(v, {
        pattern: n
      }) : b(n) && f(e) && y(e) ? S(v, {
        channel: n,
        pattern: e
      }) : p(n) ? S(v, {
        channel: n
      }) : void 0;
    }

    function C(n, e) {
      return c(e) && (e = n, n = void 0), S(m, {
        channel: n,
        action: e
      });
    }

    function O(n, e) {
      var t,
          r = null;
      return a(n) ? t = n : (d(n) ? (r = n[0], t = n[1]) : (r = n.context, t = n.fn), r && l(t) && a(r[t]) && (t = r[t])), {
        context: r,
        fn: t,
        args: e
      };
    }

    function A(n) {
      for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
        t[r - 1] = arguments[r];
      }

      return S(g, O(n, t));
    }

    function L(n) {
      return Object(r.eventChannel)(function (e) {
        return n.onComplete = function (n) {
          e(n), e(r.END);
        }, function () {};
      });
    }

    function P(n) {
      return A( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e, _yield, _yield2, _yield2$, t, r, o, u, i;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return A(L, n);

              case 2:
                e = _context.sent;
                _context.next = 5;
                return u = [h(e), C(n)], i = S(x, u), i.combinator = !0, i;

              case 5:
                _yield = _context.sent;
                _yield2 = _slicedToArray(_yield, 1);
                _yield2$ = _yield2[0];
                t = _yield2$.error;
                r = _yield2$.cancelled;
                o = _yield2$.data;

                if (!t) {
                  _context.next = 13;
                  break;
                }

                throw t;

              case 13:
                if (r) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", o);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }

    function T(n, e) {
      n.onComplete && n.onComplete(e);
    }

    function _(n) {
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var t, r;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = void 0, r = void 0;
                _context2.prev = 1;
                _context2.next = 4;
                return A(n, e);

              case 4:
                r = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);
                t = _context2.t0;

              case 10:
                _context2.prev = 10;
                _context2.next = 13;
                return S(j, {});

              case 13:
                if (!_context2.sent) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", T(e, {
                  cancelled: !0
                }));

              case 15:
                return _context2.finish(10);

              case 16:
                T(e, {
                  error: t,
                  data: r
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 7, 10, 16]]);
      });
    }

    t.d(e, "withCallback", function () {
      return _;
    }), t.d(e, "putWait", function () {
      return P;
    });
  }]);
});